import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAuthContext } from '../contexts/authContext';
import PublicRoute from './publicRoute';
import PrivateRoute from './privateRoute';
import {
    EXPIRATIONTOKEN,
    HOME,
    SIGNIN,
    USERS,
    USERNEW,
    USEREDIT,
    PAGENOTFOUND,
    ASSISTANT,
    CHAT_ASSISTANTS,
    CHAT_ASSISTANT_NEW,
    CHAT_ASSISTANT_EDIT,
    SHAREPOINT_AUTH,
    LICITACIONES_NEW,
    LICITACIONES_EDIT,
    LICITACIONES,
    SHAREPOINT_REDIRECT,
} from './paths';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import variables from '../shared/styles/settings.module.scss';
import SignIn from '../components/pages/auth/signIn';
import Home from '../components/pages/home/home';
import { Users } from '../components/pages/users';
import UserNew from '../components/pages/users/new';
import EditUser from '../components/pages/users/edit';
import ExpirationToken from '../components/components/views/expirationToken';
import PageNotFound from '../components/components/views/pageNotFound';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { AssistantPage } from '../components/pages/assistant/AssistantPage';
import { ChatAssistants } from '../components/pages/chatAssistant';
import { ChatAssistantForm } from '../components/pages/chatAssistant/form';
import SharepointAuthSuccess from '../components/pages/auth/sharepointAuth';
import { isAdminUser } from '../shared/utils/user';
import { Tenders } from '../components/pages/tender';
import { ChatMockupLicitaciones } from '../components/pages/tender/chat/chat';
import SharepointRedirect from '../components/pages/sharepointRedirect';

const AppRoutes = () => {
    const { modeTheme } = useAuthContext();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const theme = createTheme(
        {
            palette:
                modeTheme === 'darkMode'
                    ? {
                        // palette values for dark mode
                        primary: {
                            main: variables.darkColor,
                            contrastText: variables.whiteColor,
                            dark: variables.greyColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                        common: {
                            contrastText: variables.whiteColor,
                            sidebar: variables.darkColor,
                            hover: variables.greyColor,
                        },
                    }
                    : {
                        // palette values for light mode
                        primary: {
                            main: variables.primaryColor,
                            contrastText: variables.whiteColor,
                            dark: variables.quinaryColor,
                        },
                        text: {
                            primary: variables.darkColor,
                            secondary: variables.greyColor,
                        },
                        common: {
                            contrastText: variables.primaryColor,
                            sidebar: variables.violetColor,
                            hover: variables.pearlColor,
                        },
                    },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 500,
                    md: 800,
                    lg: 1200,
                    xl: 1536,
                },
            },
        },
        esES
    );

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path={HOME} element={<PrivateRoute />}>
                        <Route index element={<Home />} />
                    </Route>
                    <Route path={CHAT_ASSISTANTS} element={<PrivateRoute />}>
                        <Route index element={<ChatAssistants />} />
                        <Route
                            path={`${CHAT_ASSISTANT_EDIT}/:idChatAssistant`}
                            element={<ChatAssistantForm />}
                        />
                        {isAdminUser(type) && (
                            <Route
                                path={CHAT_ASSISTANT_NEW}
                                element={<ChatAssistantForm />}
                            />
                        )}
                    </Route>
                    {isAdminUser(type) && (
                        <>
                            <Route path={USERS} element={<PrivateRoute />}>
                                <Route index element={<Users />} />
                                <Route path={USERNEW} element={<UserNew />} />
                                <Route
                                    path={`${USEREDIT}/:idUser`}
                                    element={<EditUser />}
                                />
                            </Route>
                        </>
                    )}
                    <Route path={SIGNIN} element={<PublicRoute />}>
                        <Route index element={<SignIn />} />
                        <Route
                            path={EXPIRATIONTOKEN}
                            element={<ExpirationToken />}
                        />
                    </Route>
                    <Route
                        path={`${ASSISTANT}/:idChatAssistant`}
                        element={<AssistantPage />}
                    />
                    <Route path={LICITACIONES} element={<PrivateRoute />}>
                        <Route index element={<Tenders />} />
                        <Route
                            path={LICITACIONES_NEW}
                            element={<ChatMockupLicitaciones />}
                        />
                        <Route
                            path={`${LICITACIONES_EDIT}/:idTender`}
                            element={<ChatMockupLicitaciones />}
                        />
                    </Route>
                    <Route path={PAGENOTFOUND} element={<PageNotFound />} />
                    <Route path={SHAREPOINT_AUTH} element={<PrivateRoute />}>
                        <Route index element={<SharepointAuthSuccess />} />
                    </Route>
                    <Route
                        path={SHAREPOINT_REDIRECT}
                        element={<PrivateRoute />}
                    >
                        <Route
                            path={SHAREPOINT_REDIRECT}
                            element={<SharepointRedirect />}
                        />
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default AppRoutes;
